 <template>
  <v-layout row wrap>
    <v-flex>
      <v-card class="pa-2" v-if="showMatchList">
        <v-card-title class="grey lighten-2">
          Matched Details List
          <v-spacer></v-spacer>
          <v-btn text icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12 class="mt-3">
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs12>
            <v-card>
              <!--Search Results-->
              <v-flex xs12>
                <v-data-table
                  v-bind:headers="matchColumns"
                  v-bind:items="matchItems"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  v-bind:options.sync="paginationMatch"
                  item-key="key"
                  :loading="loading"
                  :no-data-text="noDataText"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectedMatchColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="text-right">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="primary" :disabled="disabledMatch()" :rowData="row" @click.prevent="doMatchQuery(row)"
                              >mdi-magnify</v-icon
                            >
                          </template>
                          <span>Query</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-card>
          </v-flex>
          <v-card v-if="showRiList">
            <v-flex>
              <div class="header-padding body-2">RI Panel</div>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="riMatchColumns"
                      v-bind:items="riMatchItems"
                      :server-items-length="totalItemsRIMatch"
                      :footer-props="{'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="paginationRIMatch"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedRIColumns" :key="column">{{ row.item[column] }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-card>
            </v-flex>
          </v-card>
        </v-card-text>
      </v-card>
      <div v-if="showMatchDetail">
        <matched-trans-detail :objData="matchObjData" @close=";(showMatchDetail = false), (showMatchList = true)"/>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { accountsViewMixin } from '@/mixins/accounting/accountsViewMixin'
import MatchedTransDetail from './MatchedTransDetail'

export default {
  data() {
    return {
      showMatchList: true,
      showMatchDetail: false,
      showRiList: false,
      paginationMatch: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      matchDetLabel: {
        journal: 'Journal',
        acctNo: 'Account No.',
        matchedDate: 'Matched Date',
        baseTranReceipt: 'Base Transaction is Receipt',
        contBranch: 'Branch',
        selTranPayment: 'Selected Transaction is Payment',
        branch: 'Branch',
        matchedAmt: 'Matched Amount',
        matchedLocAmt: 'Matched Local Amount',
        createdBy: 'Created by',
        mchListPrtd: 'Matched List Printed'
      },
      selectedMatchColumns: [
        'mdJournalNo',
        'mdMatchDate',
        'mdContraType',
        'mdBaseDocNo',
        'mdSelectedDocNo',
        'mdNetAmt',
        'mdLocNetAmt',
        'mdMatchBy',
        'mdOn',
        'mdProgramId'
      ],
      matchColm: [
        { text: 'Journal No.', value: 'mdJournalNo' },
        { text: 'Matched Date', value: 'mdMatchDate' },
        { text: 'Contra Type', value: 'mdContraType' },
        { text: 'Base Doc No.', value: 'mdBaseDocNo' },
        { text: 'Selected Doc No.', value: 'mdSelectedDocNo' },
        { text: 'Net Amount', value: 'mdNetAmt' },
        { text: 'Local Net Amount ', value: 'mdLocNetAmt' },
        { text: 'Matched By', value: 'mdMatchBy' },
        { text: 'Created', value: 'mdOn' },
        { text: 'Program ID', value: 'mdProgramId' }
      ],
      selectedRIColumns: ['journalNo', 'matchDate', 'contraType', 'baseDocNo', 'selectedDocNo', 'netAmt', 'locNetAmt', 'matchBy', 'on', 'programId'],
      riMatchColm: [
        { text: 'Journal No.', value: 'journalNo' },
        { text: 'Matched Date', value: 'matchDate' },
        { text: 'Contra Type', value: 'contraType' },
        { text: 'Base Doc No.', value: 'baseDocNo' },
        { text: 'Selected Doc No.', value: 'selectedDocNo' },
        { text: 'Net Amount', value: 'netAmt' },
        { text: 'Local Net Amount ', value: 'locNetAmt' },
        { text: 'Matched By', value: 'matchBy' },
        { text: 'on', value: 'on' },
        { text: 'Program ID', value: 'programId' }
      ],
      totalItemsRIMatch: 0,
      paginationRIMatch: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      matchObjData: {}
    }
  },
  mounted() {
    this.chkRbcTran()
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    disabledMatch() {
      if (this.accountData.netAmount !== this.accountData.localOutstandingBalance) {
        return false
      } else {
        return true
      }
    },
    doMatchQuery(data) {
      // If acctMaster.netAmt != acctMaster.OsBal then Enable view button else disable
      if (this.accountData.netAmount !== this.accountData.localOutstandingBalance) {
        this.matchObjData = data.item
        this.showMatchList = false
        this.showMatchDetail = true
      }
    },
    chkRbcTran() {
      if (this.accountData.rbcTran === 'Yes') {
        this.showRiList = true
      } else {
        this.showRiList = false
      }
    }
  },
  computed: {
    matchColumns() {
      let result = []
      for (const selectedMatchColumns of this.selectedMatchColumns) {
        let findCol = this.matchColm.find((a) => selectedMatchColumns === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    riMatchColumns() {
      let result = []
      for (const selectedRIColumns of this.selectedRIColumns) {
        let findCol = this.riMatchColm.find((a) => selectedRIColumns === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      return result
    }
  },
  props: {
    objData: {
      type: Object,
      default: null
    },
    accountData: {
      type: Object,
      default: null
    }
  },
  mixins: [TableConst.default, accountsAjaxCalls, accountsFilters, accountsViewMixin],
  components: { MatchedTransDetail }
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
